module.exports = __webpack_public_path__ + "img/fwlcImg3.a592abeb.png";